import Vue from 'vue'
import router from "@/router";
import access from "@/components/Statistics/access.vue";

//权限控制
Vue.directive('has',{
    bind : function(el,binding,vnode){
        //需要在DOM更新完成以后再执行以下代码，不然通过 el.parentNode 获取不到父节点，因为此时还没有绑定到
        // Vue.nextTick(function(){
        //     var role = binding.value.role
        //
        //     if(!Vue.prototype.$_has(role)){
        //         el.parentNode.removeChild(el);
        //     }
        // })


        Vue.nextTick(function(){
            let accessArray  = binding.value.role || []
            const isAccess =hasOneOf(accessArray)
            console.log('accessArray',accessArray)
            console.log('isAccess',isAccess)
            if(!isAccess){
                el.parentNode.removeChild(el);
            }
        })
    }
})
const hasOneOf = (arr)=>{
    const  storeAccess = JSON.parse(sessionStorage.getItem('permissionList'));
    const name = router.currentRoute.name
    let currentBtnAuth = []
    for(let i in storeAccess){
        const {menuUrl,btnAuth} = storeAccess[i]
        if(menuUrl === name){
            currentBtnAuth = btnAuth
            break
        }
    }
    return currentBtnAuth.some(_ => arr.indexOf(_) > -1)
}
Vue.prototype.$_has = function(role){

    if(sessionStorage.getItem('permissionList')){
        //当前角色 从sessionStorage中获取
        var currentRole = JSON.parse(sessionStorage.getItem('permissionList'));
        if(Array.isArray(role)){

            console.log("currentRole  " , currentRole);

            for(let x in currentRole) {
                const val =  currentRole[x];
                console.log("btnAuth " , val.btnAuth);
                console.log("menuUrl " , val.menuUrl);
                console.log("***   " , val.btnAuth.some(_ => role.indexOf( ) > -1)  )
                if(val.btnAuth.some(_ => role.indexOf( ) > -1)) {
                    return true;
                }
            }
            return false;
        }else{
            return currentRole.indexOf(role) >= 0;
        }


        /*if(Array.isArray(role)){
            return currentRole.some(function(ele){
                return role.indexOf(ele) >= 0
            })

        }else{
            return currentRole.indexOf(role) >= 0;
        }*/
    }
}
